// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Form from "../../bundles/Form/Form.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Request from "../../core/Request.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Form__Status from "../../bundles/Form/Form__Status.res.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as SiretInputField from "../../modules/SiretInputField.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as FieldsetLayoutPanel from "../../resources/layout-and-structure/FieldsetLayoutPanel.res.js";
import * as ResourceDetailsPage from "../../core/ResourceDetailsPage.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

function stripEmptyString(string) {
  switch (string) {
    case "" :
    case " " :
      return;
    default:
      return string;
  }
}

function orEmptyString(value) {
  return Stdlib_Option.getOr(value, "");
}

let Raw = {};

let query = Client.gql(["fragment SupplierFragment on Supplier   {\n__typename  \nid  \nupdatedAt  \narchivedAt  \ncompanyName  \nintraCommunityVat  \nphoneNumber  \nmobileNumber  \nsiretNumber  \ninternalCode  \nemail  \nnote  \n}\n"]);

function parse(value) {
  let value$1 = value.archivedAt;
  let value$2 = value.intraCommunityVat;
  let value$3 = value.phoneNumber;
  let value$4 = value.mobileNumber;
  let value$5 = value.siretNumber;
  let value$6 = value.internalCode;
  let value$7 = value.email;
  let value$8 = value.note;
  return {
    __typename: value.__typename,
    id: value.id,
    updatedAt: Scalar.Datetime.parse(value.updatedAt),
    archivedAt: !(value$1 == null) ? Scalar.Datetime.parse(value$1) : undefined,
    companyName: value.companyName,
    intraCommunityVat: !(value$2 == null) ? value$2 : undefined,
    phoneNumber: !(value$3 == null) ? value$3 : undefined,
    mobileNumber: !(value$4 == null) ? value$4 : undefined,
    siretNumber: !(value$5 == null) ? value$5 : undefined,
    internalCode: !(value$6 == null) ? value$6 : undefined,
    email: !(value$7 == null) ? value$7 : undefined,
    note: !(value$8 == null) ? Scalar.Text.parse(value$8) : undefined
  };
}

function serialize(value) {
  let value$1 = value.note;
  let note = value$1 !== undefined ? Scalar.Text.serialize(value$1) : null;
  let value$2 = value.email;
  let email = value$2 !== undefined ? value$2 : null;
  let value$3 = value.internalCode;
  let internalCode = value$3 !== undefined ? value$3 : null;
  let value$4 = value.siretNumber;
  let siretNumber = value$4 !== undefined ? value$4 : null;
  let value$5 = value.mobileNumber;
  let mobileNumber = value$5 !== undefined ? value$5 : null;
  let value$6 = value.phoneNumber;
  let phoneNumber = value$6 !== undefined ? value$6 : null;
  let value$7 = value.intraCommunityVat;
  let intraCommunityVat = value$7 !== undefined ? value$7 : null;
  let value$8 = value.companyName;
  let value$9 = value.archivedAt;
  let archivedAt = value$9 !== undefined ? Scalar.Datetime.serialize(value$9) : null;
  let value$10 = value.updatedAt;
  let value$11 = Scalar.Datetime.serialize(value$10);
  let value$12 = value.id;
  let value$13 = value.__typename;
  return {
    __typename: value$13,
    id: value$12,
    updatedAt: value$11,
    archivedAt: archivedAt,
    companyName: value$8,
    intraCommunityVat: intraCommunityVat,
    phoneNumber: phoneNumber,
    mobileNumber: mobileNumber,
    siretNumber: siretNumber,
    internalCode: internalCode,
    email: email,
    note: note
  };
}

function verifyArgsAndParse(_SupplierFragment, value) {
  return parse(value);
}

function verifyName(_fragmentName) {
  
}

let SupplierFragment = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};

let Raw$1 = {};

let query$1 = Client.gql([
  "query SupplierQuery($id: ID!)  {\nsupplier(id: $id)  {\n...SupplierFragment   \n}\n\n}\n",
  ""
], query);

function parse$1(value) {
  let value$1 = value.supplier;
  return {
    supplier: !(value$1 == null) ? parse(value$1) : undefined
  };
}

function serialize$1(value) {
  let value$1 = value.supplier;
  let supplier = value$1 !== undefined ? serialize(value$1) : null;
  return {
    supplier: supplier
  };
}

function serializeVariables(inp) {
  return {
    id: inp.id
  };
}

function makeVariables(id, param) {
  return {
    id: id
  };
}

let SupplierQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables
});

let use = include.use;

let SupplierQuery_refetchQueryDescription = include.refetchQueryDescription;

let SupplierQuery_useLazy = include.useLazy;

let SupplierQuery_useLazyWithVariables = include.useLazyWithVariables;

let SupplierQuery = {
  SupplierQuery_inner: SupplierQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  refetchQueryDescription: SupplierQuery_refetchQueryDescription,
  use: use,
  useLazy: SupplierQuery_useLazy,
  useLazyWithVariables: SupplierQuery_useLazyWithVariables
};

let Raw$2 = {};

let query$2 = Client.gql([
  "mutation updateSupplier($id: ID!, $supplierInput: InputUpdateSupplier!)  {\nupdateSupplier(id: $id, supplierInput: $supplierInput)  {\n...SupplierFragment   \n}\n\n}\n",
  ""
], query);

function parse$2(value) {
  let value$1 = value.updateSupplier;
  return {
    updateSupplier: parse(value$1)
  };
}

function serialize$2(value) {
  let value$1 = value.updateSupplier;
  let updateSupplier = serialize(value$1);
  return {
    updateSupplier: updateSupplier
  };
}

function serializeInputObjectInputUpdateSupplier(inp) {
  let a = inp.companyName;
  let a$1 = inp.intraCommunityVat;
  let a$2 = inp.siretNumber;
  let a$3 = inp.phoneNumber;
  let a$4 = inp.mobileNumber;
  let a$5 = inp.email;
  let a$6 = inp.note;
  let a$7 = inp.internalCode;
  return {
    companyName: a !== undefined ? a : undefined,
    intraCommunityVat: a$1 !== undefined ? a$1 : undefined,
    siretNumber: a$2 !== undefined ? a$2 : undefined,
    phoneNumber: a$3 !== undefined ? a$3 : undefined,
    mobileNumber: a$4 !== undefined ? a$4 : undefined,
    email: a$5 !== undefined ? a$5 : undefined,
    note: a$6 !== undefined ? a$6 : undefined,
    internalCode: a$7 !== undefined ? a$7 : undefined
  };
}

function serializeVariables$1(inp) {
  return {
    id: inp.id,
    supplierInput: serializeInputObjectInputUpdateSupplier(inp.supplierInput)
  };
}

function makeVariables$1(id, supplierInput, param) {
  return {
    id: id,
    supplierInput: supplierInput
  };
}

function makeInputObjectInputUpdateSupplier(companyName, intraCommunityVat, siretNumber, phoneNumber, mobileNumber, email, note, internalCode, param) {
  return {
    companyName: companyName,
    intraCommunityVat: intraCommunityVat,
    siretNumber: siretNumber,
    phoneNumber: phoneNumber,
    mobileNumber: mobileNumber,
    email: email,
    note: note,
    internalCode: internalCode
  };
}

let SupplierUpdateMutation_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputUpdateSupplier: serializeInputObjectInputUpdateSupplier,
  makeVariables: makeVariables$1,
  makeInputObjectInputUpdateSupplier: makeInputObjectInputUpdateSupplier
};

let include$1 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$2,
  Raw: Raw$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$1
});

let use$1 = include$1.use;

let SupplierUpdateMutation_useWithVariables = include$1.useWithVariables;

let SupplierUpdateMutation = {
  SupplierUpdateMutation_inner: SupplierUpdateMutation_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputUpdateSupplier: serializeInputObjectInputUpdateSupplier,
  makeVariables: makeVariables$1,
  makeInputObjectInputUpdateSupplier: makeInputObjectInputUpdateSupplier,
  use: use$1,
  useWithVariables: SupplierUpdateMutation_useWithVariables
};

function get(values, field) {
  switch (field) {
    case "CompanyName" :
      return values.companyName;
    case "Email" :
      return values.email;
    case "PhoneNumber" :
      return values.phoneNumber;
    case "MobileNumber" :
      return values.mobileNumber;
    case "IntraCommunityVat" :
      return values.intraCommunityVat;
    case "SiretNumber" :
      return values.siretNumber;
    case "InternalCode" :
      return values.internalCode;
    case "Note" :
      return values.note;
  }
}

function set(values, field, value) {
  switch (field) {
    case "CompanyName" :
      return {
        companyName: value,
        email: values.email,
        phoneNumber: values.phoneNumber,
        mobileNumber: values.mobileNumber,
        intraCommunityVat: values.intraCommunityVat,
        siretNumber: values.siretNumber,
        internalCode: values.internalCode,
        note: values.note
      };
    case "Email" :
      return {
        companyName: values.companyName,
        email: value,
        phoneNumber: values.phoneNumber,
        mobileNumber: values.mobileNumber,
        intraCommunityVat: values.intraCommunityVat,
        siretNumber: values.siretNumber,
        internalCode: values.internalCode,
        note: values.note
      };
    case "PhoneNumber" :
      return {
        companyName: values.companyName,
        email: values.email,
        phoneNumber: value,
        mobileNumber: values.mobileNumber,
        intraCommunityVat: values.intraCommunityVat,
        siretNumber: values.siretNumber,
        internalCode: values.internalCode,
        note: values.note
      };
    case "MobileNumber" :
      return {
        companyName: values.companyName,
        email: values.email,
        phoneNumber: values.phoneNumber,
        mobileNumber: value,
        intraCommunityVat: values.intraCommunityVat,
        siretNumber: values.siretNumber,
        internalCode: values.internalCode,
        note: values.note
      };
    case "IntraCommunityVat" :
      return {
        companyName: values.companyName,
        email: values.email,
        phoneNumber: values.phoneNumber,
        mobileNumber: values.mobileNumber,
        intraCommunityVat: value,
        siretNumber: values.siretNumber,
        internalCode: values.internalCode,
        note: values.note
      };
    case "SiretNumber" :
      return {
        companyName: values.companyName,
        email: values.email,
        phoneNumber: values.phoneNumber,
        mobileNumber: values.mobileNumber,
        intraCommunityVat: values.intraCommunityVat,
        siretNumber: value,
        internalCode: values.internalCode,
        note: values.note
      };
    case "InternalCode" :
      return {
        companyName: values.companyName,
        email: values.email,
        phoneNumber: values.phoneNumber,
        mobileNumber: values.mobileNumber,
        intraCommunityVat: values.intraCommunityVat,
        siretNumber: values.siretNumber,
        internalCode: value,
        note: values.note
      };
    case "Note" :
      return {
        companyName: values.companyName,
        email: values.email,
        phoneNumber: values.phoneNumber,
        mobileNumber: values.mobileNumber,
        intraCommunityVat: values.intraCommunityVat,
        siretNumber: values.siretNumber,
        internalCode: values.internalCode,
        note: value
      };
  }
}

let SupplierEditFormLenses_ = {
  get: get,
  set: set
};

let SupplierEditFormLenses = {
  get: get,
  set: set
};

let SupplierEditForm = Form.Make(SupplierEditFormLenses);

let supplierEditFormInitialValues = {
  companyName: "",
  email: "",
  phoneNumber: "",
  mobileNumber: "",
  intraCommunityVat: "",
  siretNumber: "",
  internalCode: "",
  note: ""
};

let supplierEditFormSchema = [{
    TAG: "StringNotEmpty",
    _0: "CompanyName"
  }];

function supplierEditFormInitialValuesFromQueryResult(queryResult) {
  return {
    companyName: queryResult.companyName,
    email: Stdlib_Option.getOr(queryResult.email, ""),
    phoneNumber: Stdlib_Option.getOr(queryResult.phoneNumber, ""),
    mobileNumber: Stdlib_Option.getOr(queryResult.mobileNumber, ""),
    intraCommunityVat: Stdlib_Option.getOr(queryResult.intraCommunityVat, ""),
    siretNumber: Stdlib_Option.getOr(queryResult.siretNumber, ""),
    internalCode: Stdlib_Option.getOr(queryResult.internalCode, ""),
    note: Stdlib_Option.getOr(queryResult.note, "")
  };
}

function mutationVariablesFromIdAndFormValues(id, formValues) {
  return {
    id: id,
    supplierInput: makeInputObjectInputUpdateSupplier(formValues.companyName, stripEmptyString(formValues.intraCommunityVat), stripEmptyString(formValues.siretNumber), stripEmptyString(formValues.phoneNumber), stripEmptyString(formValues.mobileNumber), stripEmptyString(formValues.email), stripEmptyString(formValues.note), stripEmptyString(formValues.internalCode), undefined)
  };
}

function SupplierEditPage$SupplierEditFormInformationFieldset$SiretField(props) {
  let match = SupplierEditForm.useField("SiretNumber", undefined, undefined, undefined, undefined);
  let onFocus = match.onFocus;
  return JsxRuntime.jsx(SiretInputField.make, {
    value: match.value,
    errored: Stdlib_Option.isSome(match.error),
    focused: match.focused,
    required: match.required,
    onChange: match.onChange,
    onCompanyFound: props.onCompanyFound,
    onFocus: () => onFocus(),
    onBlur: match.onBlur
  });
}

let SiretField = {
  make: SupplierEditPage$SupplierEditFormInformationFieldset$SiretField
};

function SupplierEditPage$SupplierEditFormInformationFieldset(props) {
  let dispatch = SupplierEditForm.useFormDispatch();
  let onCompanyFound = company => {
    if (company === undefined) {
      return;
    }
    let company$1 = company.company;
    dispatch({
      TAG: "FieldValueChanged",
      _0: "CompanyName",
      _1: param => company$1.corporateName
    });
  };
  return JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
    title: I18n.t("General information"),
    description: I18n.t("Complete the essential information of your new supplier."),
    children: [
      JsxRuntime.jsx(SupplierEditForm.InputText.make, {
        field: "CompanyName",
        label: I18n.t("Company name"),
        placeholder: I18n.t("Company name")
      }),
      JsxRuntime.jsx(SupplierEditForm.InputText.make, {
        field: "Email",
        label: I18n.t("Email address"),
        placeholder: I18n.t("contact@company.com")
      }),
      JsxRuntime.jsxs(Group.make, {
        children: [
          JsxRuntime.jsx(SupplierEditForm.InputPhone.make, {
            label: I18n.t("Home phone"),
            field: "PhoneNumber",
            placeholder: "02 11 22 33 44"
          }),
          JsxRuntime.jsx(SupplierEditForm.InputPhone.make, {
            label: I18n.t("Mobile phone"),
            field: "MobileNumber",
            placeholder: "06 11 22 33 44"
          })
        ]
      }),
      JsxRuntime.jsxs(Group.make, {
        children: [
          JsxRuntime.jsx(SupplierEditForm.InputText.make, {
            field: "IntraCommunityVat",
            label: I18n.t("TVA number"),
            placeholder: "FR 40 123456789",
            copyable: true
          }),
          JsxRuntime.jsx(SupplierEditPage$SupplierEditFormInformationFieldset$SiretField, {
            onCompanyFound: onCompanyFound
          })
        ]
      }),
      JsxRuntime.jsx(SupplierEditForm.InputText.make, {
        field: "InternalCode",
        label: I18n.t("Internal code"),
        placeholder: I18n.t("Internal code"),
        copyable: true
      })
    ]
  });
}

let SupplierEditFormInformationFieldset = {
  SiretField: SiretField,
  make: SupplierEditPage$SupplierEditFormInformationFieldset
};

function SupplierEditPage$SuppplierEditFormActionsBar(props) {
  let id = props.id;
  let match = use$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  let formState = SupplierEditForm.useFormState();
  let match$1 = Navigation.useGoBack();
  let onGoBack = match$1[1];
  return JsxRuntime.jsx(ResourceDetailsPage.ActionsBar.make, {
    items: [
      Form__Status.isPristine(formState.status) && match$1[0] ? JsxRuntime.jsx(Button.make, {
          label: I18n.t("Discard"),
          onPress: () => onGoBack()
        }) : JsxRuntime.jsx(SupplierEditForm.CancelButton.make, {
          label: I18n.t("Discard")
        }),
      JsxRuntime.jsx(SupplierEditForm.SubmitButton.make, {
        label: I18n.t("Save"),
        tone: "success",
        onSubmit: (param, values) => Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, mutationVariablesFromIdAndFormValues(id, values))), undefined, param => param.updateSupplier.id)
      })
    ]
  });
}

let SuppplierEditFormActionsBar = {
  make: SupplierEditPage$SuppplierEditFormActionsBar
};

function SupplierEditPage(props) {
  let supplierShowRoute = props.supplierShowRoute;
  let navigate = Navigation.useNavigate();
  let asyncQueryResult = AsyncResult.map(ApolloHelpers.queryResultToAsyncResult(use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
    id: props.id
  })), result => {
    if (result.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
    let supplier = result._0.supplier;
    if (supplier !== undefined) {
      return {
        TAG: "Ok",
        _0: supplier
      };
    } else {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
  });
  let match = React.useState(() => {});
  let setNotificationError = match[1];
  let notificationError = match[0];
  let onSubmitFailure = error => setNotificationError(param => error);
  let onSubmitSuccess = response => {
    if (response !== undefined) {
      return navigate({
        replace: true
      }, supplierShowRoute(response));
    } else {
      return setNotificationError(param => Request.serverErrorMessage);
    }
  };
  let formId;
  if (typeof asyncQueryResult !== "object") {
    formId = undefined;
  } else if (asyncQueryResult.TAG === "Reloading") {
    let queryResult = asyncQueryResult._0;
    formId = queryResult.TAG === "Ok" ? queryResult._0.id : undefined;
  } else {
    let queryResult$1 = asyncQueryResult._0;
    formId = queryResult$1.TAG === "Ok" ? queryResult$1._0.id : undefined;
  }
  let formInitialValues;
  if (typeof asyncQueryResult !== "object") {
    formInitialValues = supplierEditFormInitialValues;
  } else if (asyncQueryResult.TAG === "Reloading") {
    let queryResult$2 = asyncQueryResult._0;
    formInitialValues = queryResult$2.TAG === "Ok" ? supplierEditFormInitialValuesFromQueryResult(queryResult$2._0) : supplierEditFormInitialValues;
  } else {
    let queryResult$3 = asyncQueryResult._0;
    formInitialValues = queryResult$3.TAG === "Ok" ? supplierEditFormInitialValuesFromQueryResult(queryResult$3._0) : supplierEditFormInitialValues;
  }
  let formPropState = SupplierEditForm.useFormPropState({
    id: formId,
    initialValues: formInitialValues,
    schema: supplierEditFormSchema,
    onSubmitFailure: onSubmitFailure,
    onSubmitSuccess: onSubmitSuccess
  });
  let notificationBanner;
  if (notificationError !== undefined) {
    let onRequestClose = () => setNotificationError(param => {});
    notificationBanner = JsxRuntime.jsx(ResourceDetailsPage.NotificationBanner.make, {
      value: {
        TAG: "Error",
        _0: notificationError
      },
      onRequestClose: onRequestClose
    });
  } else {
    notificationBanner = null;
  }
  if (typeof asyncQueryResult !== "object") {
    return JsxRuntime.jsx(Placeholder.make, {
      status: "Loading"
    });
  }
  if (asyncQueryResult.TAG !== "Done") {
    return JsxRuntime.jsx(Placeholder.make, {
      status: "Loading"
    });
  }
  let queryResult$4 = asyncQueryResult._0;
  if (queryResult$4.TAG !== "Ok") {
    return JsxRuntime.jsx(Placeholder.make, {
      status: "Error"
    });
  }
  let actionsBar = JsxRuntime.jsx(SupplierEditPage$SuppplierEditFormActionsBar, {
    id: queryResult$4._0.id
  });
  return JsxRuntime.jsx(SupplierEditForm.Core.Provider.make, {
    children: JsxRuntime.jsx(ResourceDetailsPage.make, {
      title: I18n.t("Edition supplier"),
      subtitle: formPropState[0].values.companyName,
      actionsBar: actionsBar,
      notificationBanner: notificationBanner,
      children: JsxRuntime.jsx(SupplierEditPage$SupplierEditFormInformationFieldset, {})
    }),
    propState: formPropState
  });
}

let make = SupplierEditPage;

export {
  stripEmptyString,
  orEmptyString,
  SupplierFragment,
  SupplierQuery,
  SupplierUpdateMutation,
  SupplierEditFormLenses_,
  SupplierEditFormLenses,
  SupplierEditForm,
  supplierEditFormInitialValues,
  supplierEditFormSchema,
  supplierEditFormInitialValuesFromQueryResult,
  mutationVariablesFromIdAndFormValues,
  SupplierEditFormInformationFieldset,
  SuppplierEditFormActionsBar,
  make,
}
/* query Not a pure module */
